import scanInput from './scan-input.vue'
export default scanInput
